import React from 'react';
import styled from 'styled-components';
import { h } from '@debbie/cortex/dist';
import THEME from '../../theme';
import { useAllCreditors } from '@debbie/cortex/dist/creditors';
const CreditorSelector = (props) => {
    const allCreditors = useAllCreditors();
    return h.hasData(allCreditors) ? (React.createElement(Wrapper, null, allCreditors.data.map((creditor) => {
        return (React.createElement(Creditor, { key: creditor.id, onClick: () => {
                props.onSelect(creditor);
            } }, creditor.name));
    }))) : (React.createElement(React.Fragment, null));
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid lightgray;
  border-radius: 5px;
  overflow: hidden;
`;
const Creditor = styled.div `
  padding: 10px;
  width: 100%;
  cursor: pointer;
  background: #fff;
  :hover {
    background: ${THEME.SELECTED_BLUE};
  }
`;
export default CreditorSelector;
//# sourceMappingURL=CreditorSelector.js.map